// extracted by mini-css-extract-plugin
module.exports = {"stopWatch":"StopWatch_stopWatch__3OrHh","inAnimation":"StopWatch_inAnimation___xu83","pop-in":"StopWatch_pop-in__3xXYD"};